declare namespace $ {

	export class $bog_builderui_div extends $mol_view {
	}
	
}

//# sourceMappingURL=div.view.tree.d.ts.map